import { render, staticRenderFns } from "./AddModuleWindow.vue?vue&type=template&id=5a3d5078"
import script from "./AddModuleWindow.vue?vue&type=script&lang=js"
export * from "./AddModuleWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports